module.exports = __webpack_public_path__ + "img/IMG-20191123-WA0047.a2c3f1fd.jpg";